<template>
    <div class="d-flex justify-content-center mb-3 gap-y20" :class="{[optional_class]: true}">
        <slot />
    </div>
    <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-left gap-y20">
            <slot name="back" />
        </div>
        <div class="d-flex justify-content-right gap-y20">
            <slot name="negative" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ButtonWrap',
    props: {
        optional_class: {
            type: String,
            default: ''
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .gap-y20 {gap: 0 20px}
</style>
